import { h, Component } from "preact";
// import Page from "../../../services/page-data-feed";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";


export let PopupLink = (url, name = null, width = '800', height = '600') => {
    const myPopup = window.open(
        url,
        !!name? name : 'popup',
        'width='+width+',height='+height+',location=no,menubar=no,status=no,toolbar=no,scrollbars=yes'
    );
    myPopup.focus();
}

export function openPopup(url, target = '') {
	return window.open(url, target, 'popup');
}

/*
export let PopupPanelButtons = () => Page.user.isLogged() && (
    <div class="panel">
        <h4 class="flex panel-h4-flex gap-1">
            <a
                href="javascript:void(0);"
                class="panel-flex-title button-minimal text-xs font-bold rounded leading-6 px-2 whitespace-pre"
                onClick={e => PopupLink('/popup/stats')}
            >
                <span class="flex w-full items-center justify-center">
                    <span class="w-full"><Trans>Statistiche</Trans></span>
                    <i class="fa fa-check" />
                </span>
            </a>
            <a
                href="javascript:void(0);"
                class="panel-flex-title button-minimal text-xs font-bold rounded leading-6 px-2 whitespace-pre"
                onClick={e => PopupLink('/popup/results')}
            >
                <span class="flex w-full items-center justify-center">
                    <span class="w-full"><Trans>Risultati</Trans></span>
                    <i class="fa fa-check" />
                </span>
            </a>
        </h4>
    </div>
);

export default class PopupPage extends Component {
    componentWillMount() {
        // document.querySelector('body').style.overflow = 'hidden';
    }

    getPopupUrl() {
        switch (this.props.page) {
            default:
            case 'stats': return 'https://s5.sir.sportradar.com/betinaction/pt/1';
            case 'results': return 'https://ls.sir.sportradar.com/betinaction/pt';
        }
    }

    render() {
        return <iframe
            src={this.getPopupUrl()}
            style="overflow:auto; border:none; height:100vh; width:100vw;"
        />;
    }
}*/
